export default __webpack_public_path__ + "static/media/list-car.b2fa6523.png";